import Api from "../../../api/Api";
import { TransformSendData } from "./TransformSendData";

export const saveAuditResult = async(audit_id) => {
    try {
        const local_data=JSON.parse(localStorage.getItem(`save_${audit_id}`));
        const save_data=TransformSendData(local_data.data);
        const response = await Api({
            method:"put",
            url:`/audits/@${audit_id}`,
            headers:{},
            data:save_data
        })
        alert(`Данные сохранены.`);
        //очистка данных из локального хранилища
        localStorage.removeItem(`save_${audit_id}`);
        //перезагрузка страницы
        window.location.reload();
    } catch (error) {
        alert(`Ошибка при отправке результатов аудита \n ${error}`);
    }
}